import name from './name'

const selectSliceData = state => state[name]

const selectError = state => selectSliceData(state).error

export { selectError }
